import Axios from "../Axios";
// import transport_alt from './Content/images/transporter_logo.png'
import transport_alt from "../Content/images/transporter_logo.png";
import axios from "axios";
import { Urls } from "../Urls";
import {
  currentRequestTimeStamp,
  getProcurementID,
  DECRYPTION_KEY_HEX,
} from "./Constants";
import { toast } from "react-toastify";
import { Constants } from "./Constants";
import { database } from "./firebase/firebaseRealtime";
import CryptoJS from "crypto-js";
import * as XLSX from "xlsx";
import {
  get,
  onValue,
  ref,
  serverTimestamp,
  set,
  update,
} from "firebase/database";
import { event } from "react-ga";

/**
 * Makes an HTTP request using Axios based on the provided method and key.
 *
 * @function
 * @param {string} [key="all"] - The key used in the request URL.
 * @param {string} method - The HTTP method to use ('get', 'post', 'put', 'rate-card-list', 'lsp-rate-card').
 * @param {Object} [data={}] - The data to send with the request (for 'post' and 'put' methods).
 * @param {string} [id=""] - Optional ID to use in the request.
 * @returns {Promise} The Axios promise for the request.
 */
export const AxiosRequestor = (key = "all", method, data, id = "") => {
  let procurement_id = "";
  if (id) {
    procurement_id = id;
  } else {
    procurement_id = getProcurementID();
  }
  if(!procurement_id || procurement_id==="")return;
  switch (method) {
    case "get":
      return Axios.get(
        `${Urls.procurements}?route=procurement_id&procurement_id=${procurement_id}&field=${key}`
      );
    case "post":
      return Axios.post(
        `${Urls.procurements}?route=procurement_id&procurement_id=${procurement_id}`,
        data
      );
    case "put":
      return Axios.put(
        `${Urls.procurements}?route=procurement_id&procurement_id=${procurement_id}`,
        data
      );
    case "rate-card-list":
      return Axios.get(
        `${Urls.procurements}?route=procurement_id&procurement_id=${procurement_id}/rate_card_list`
      );
    case "lsp-rate-card":
      return Axios.get(
        `${Urls.procurements}?route=procurement_id&procurement_id=${procurement_id}/rate_card-${data}`
      );
    default:
      return "";
  }
};

/**
 * Retrieves the folder name for the company based on the user's email domain.
 *
 * @function
 * @param {string} userEmail - The current user's email.
 * @returns {string} The folder name based on the user's email domain.
 */
export const getCompanyFolderName = function (userEmail) {
  let domain = userEmail ? userEmail.split("@").pop() : "unknown-company";
  domain = domain.replace(".", "-");
  return domain;
};

/**
 * Retrieves the folder name for the user based on their email and company ID.
 *
 * @function
 * @param {string} userEmail - The current user's email.
 * @param {string} profileCompanyId - The current user's company ID.
 * @returns {string} The folder name for the user.
 */
export const getUserFolderName = function (userEmail, profileCompanyId) {
  return userEmail ? profileCompanyId : "unknown-user";
};

/**
 * Generates initials from a full name.
 *
 * @function
 * @param {string} name - The full name from which to generate initials.
 * @returns {string} The initials derived from the full name.
 */
export const getInitials = (name) => {
  if (!name) return "T";
  let ini = name.split(" ");
  let initials = "";
  if (ini.length > 1) initials = ini[0].charAt(0) + ini[1].charAt(0);
  else if (ini.length === 1) initials = ini[0].charAt(0);
  else if (ini.length === 0) initials = "T";
  return initials.toLocaleUpperCase();
};

/**
 * Converts a string to title case.
 *
 * @function
 * @param {string} str - The string to convert to title case.
 * @returns {string} The string in title case.
 */
export const titleCase = (str) => {
  let splitStr = str?.toLowerCase().split(" ");
  for (let i = 0; i < splitStr?.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr?.join(" ");
};

/**
 * Retrieves the source URL for an image, falling back to a default image if necessary.
 *
 * @function
 * @param {string} logo - The name of the logo image file.
 * @returns {string} The full URL to the image.
 */
export const getImageSrc = (logo) => {
  if (logo && logo.length > 1) return `${Urls.FileUrl}/${logo}`;
  return transport_alt;
};

/**
 * Sets a fallback image if the original image fails to load.
 *
 * @function
 * @param {Event} e - The event object from the image error event.
 * @returns {void}
 */
export const imageFallBack = (e) => {
  e.target.src = transport_alt;
};

/**
 * Makes an HTTP request to retrieve rate card information.
 *
 * @function
 * @param {string} [key="all"] - The key used in the request URL.
 * @param {string} [transporterId=""] - The transporter ID used in the request URL.
 * @param {string} [procurement=""] - The procurement ID used in the request URL.
 * @returns {Promise} The Axios promise for the request.
 */
export const RateCardAxiosRequestor = (
  key = "all",
  transporterId = "",
  procurement = ""
) => {
  let procurementId = "";
  if (procurement) {
    procurementId = procurement;
  } else {
    procurementId = getProcurementID();
  }
  switch (key) {
    case "all":
      return Axios.get(
        `${Urls.procurements}?route=procurement_id&procurement_id=${procurementId}/rate_card_list`
      );
    case "lsp":
      return Axios.get(
        `${Urls.procurements}?route=procurement_id&procurement_id=${procurementId}/rate_card-${transporterId}?transporter_id=${transporterId}`
      );
    case "compiled":
      return Axios.get(
        `${Urls.procurements}?route=procurement_id&procurement_id=${procurementId}/compiled_rate_card`
      );
    case "analyzed":
      return Axios.get(
        `${Urls.procurements}?route=procurement_id&procurement_id=${procurementId}/analyzed_rate_card`
      );
    default:
      return "";
  }
};

/**
 * Retrieves the current time zone of the user.
 *
 * @function
 * @returns {string} The time zone of the user.
 */
export const getTimeZone = () => {
  let datefortimezone = new Date();
  let new_date = datefortimezone.toString();
  let dateparts = new_date.split("(");
  let str2 = dateparts[1];
  let str3 = str2.split(")")[0];
  let timezone = str3;
  return timezone;
};

/**
 * Validates if the provided email address is a valid business email.
 *
 * @function
 * @param {string} value - The email address to validate.
 * @returns {boolean} True if the email is valid, false otherwise.
 */
export const isValidBusinessEmail = (value) => {
  let validEmail = true;
  let regexValidation =
    value && new RegExp(Constants.EmailRegEx).test(value.trim());
  if (!regexValidation) {
    validEmail = false;
    // console.log(validEmail)
  } else {
    let EmailDomain = value.split("@");
    // console.log(EmailDomain)
    if (EmailDomain.length < 2) {
      validEmail = false;
      // console.log(validEmail)
    } else {
      validEmail =
        Constants.restrictedDomains.filter(
          (email) => email.trim() === EmailDomain[1].trim()
        ).length === 0
          ? true
          : false;
    }
  }
  return validEmail;
};

/**
 * Formats a date string into local date and time format.
 *
 * @function
 * @param {string} [dateString=""] - The date string to format.
 * @returns {string} The formatted date and time string.
 */
export const getLocalDateTime = (dateString = "") => {
  return dateString
    ? `${new Date(dateString).toLocaleDateString()}  ${new Date(
      dateString
    ).toLocaleTimeString()}`
    : `${new Date().toLocaleDateString()}_${new Date().toLocaleTimeString()}`;
};

/**
 * Sends an email using the provided email body and displays success or error messages.
 *
 * @function
 * @param {Object} email_body - The body of the email to send.
 * @param {Function} loader - Function to toggle the loading state.
 * @param {string} [success_message=""] - Optional success message to display.
 * @param {string} [error_message=""] - Optional error message to display.
 * @returns {void}
 */
export const mailerAPI = (
  email_body,
  loader,
  success_message = "",
  error_message = ""
) => {
  axios
    .post(Urls.logURL, email_body)
    .then(() => {
      if (loader) loader(false);
      if (success_message) toast.success(success_message);
    })
    .catch(() => {
      if (loader) loader(false);
      if (error_message) toast.error(error_message);
    });
};

/**
 * Creates a new auction in the Realtime Database.
 *
 * @function
 * @param {string} auctionId - The ID of the auction to create.
 * @param {Object} cleanedAuctionData - The cleaned auction data to save.
 * @param {string} type - The type of auction (e.g., "active" or "completed").
 * @returns {void}
 */
export const createNewAuctionInDB = (auctionId, cleanedAuctionData, type) => {
  let auctionsRef = ref(database, type);
  get(auctionsRef)
    .then((items) => {
      let final_auction = items.val() || {}; //get the data if present in RTDB
      cleanedAuctionData["db_server_timestamp"] = serverTimestamp(); //add server timestamp from firebase RTDB timestamp
      final_auction[auctionId] = cleanedAuctionData; // add new auction data into final_auction
      return set(auctionsRef, final_auction); // update RTDB with the updated auctions list
    })
    .catch((error) => {
      console.error("Error creating new auction:", error);
    });
};

/**
 * Fetches live transporters for a specific auction and updates the state.
 *
 * @function
 * @param {string} auction_id - The ID of the auction.
 * @param {Function} setLiveTransporters - Function to update the state with live transporters.
 * @returns {Function} A cleanup function to unsubscribe from the database reference.
 */
export const liveTransporters = (auction_id, setLiveTransporters) => {
  const auctionStatus = ref(
    database,
    `auctions/${auction_id}/transporter_status`
  ); //reference to firebase RTDB with child node transporter_status
  const unSub = onValue(auctionStatus, (snapshot) => {
    //listen to the updated value
    const data = snapshot.val(); //get the snapshot of the value
    if (data && data.length > 0) {
      //check if data is valid and not empty
      let final_live_transporters = data.filter(
        (items) => items?.status === "enter"
      );
      setLiveTransporters(final_live_transporters);
    }
  });
  return () => {
    unSub();
  };
};

/**
 * Updates the timer dates based on the resume time for an auction.
 *
 * @function
 * @param {string} auction_id - The ID of the auction.
 * @param {Function} setTimerDate - Function to update the timer date.
 * @param {Function} setNewTimerDate - Function to update the new timer date.
 * @param {number} time - Additional time to add to the timer.
 * @returns {Function} A cleanup function to unsubscribe from the database reference.
 */
export const updatedTimeForResume = (
  auction_id,
  setTimerDate,
  setNewTimerDate,
  time
) => {
  const updatedTimeRef = ref(database, `auctions/${auction_id}/closed_at_db`); //reference to firebase RTDB with respect to passed auctionId
  // let updatedTimes = onValue(updatedTimeRef, (snap) => { //listen to updated value
  //   const data = snap.val(); //snapshot of updated values
  //   if (data) { //verify if there is any data
  //     let date = new Date(data?.live_timestamp_db); //store live timestamp from firebase RTDB into date variable
  //     date.setMinutes(date.getMinutes() + Number(data?.auction_duration)); //add duration into the live timestamp
  //     setTimerDate(date); //set final date
  //     let dateForManual = new Date(data?.live_timestamp_db); //store live timestamp from firebase RTDB into date variable
  //     dateForManual.setMinutes(
  //       dateForManual.getMinutes() + Number(data?.auction_duration) + time
  //     ); //add duration into the live timestamp along with the minutes by which user incremented or decremented the resume time.
  //     setNewTimerDate(dateForManual); //update in state
  //   }
  // });
  let updatedTimes = onValue(updatedTimeRef, (snap) => {
    const data = snap.val(); //snapshot of the value
    if (data) {
      let date = new Date(data);
      setTimerDate(date);
      let ManualDate = new Date(data);
      ManualDate = ManualDate.setMinutes(ManualDate.getMinutes() + time);
      setNewTimerDate(ManualDate);
    }
  });
  return () => {
    updatedTimes();
  };
};

/**
 * Fetches and updates the paused timestamp for a specific auction.
 *
 * @function
 * @param {string} auction_id - The ID of the auction.
 * @param {Function} setPausedTime - Function to update the paused timestamp.
 * @returns {void}
 */
export const updatedPausedTImestamp = (auction_id, setPausedTime) => {
  const timeStamp = ref(database, `auctions/${auction_id}/paused_at_db`); //reference to firebase RTDB with respect to passed auctionId and child node paused_at_db
  return onValue(timeStamp, (snap) => {
    //listen to value
    const data = snap.val(); //snapshot of the value
    setPausedTime(new Date(data)); //update the pause time in state
  });
};

/**
 * Updates the auction's timer based on resume time and paused time.
 *
 * @function
 * @param {string} auction_id - The ID of the auction.
 * @param {Function} setTimerDate - Function to update the timer date.
 * @returns {Function} A cleanup function to unsubscribe from the database reference.
 */
export const updatedTime = (auction_id, setTimerDate) => {
  const updatedTimeRef = ref(database, `auctions/${auction_id}/closed_at_db`); //reference to firebase RTDB with respect to passed auctionId
  // let updatedTimes = onValue(updatedTimeRef, (snap) => {  //listen to value
  //   const data = snap.val(); //snapshot of the value
  //   if (data && data.resumed_at_db) { //check if data and resumed_at_db present
  //     let paused_timestamp = new Date(data?.paused_at_db); //convert into date object
  //     let resume_timestamp = new Date(data?.resumed_at_db); //convert into date object
  //     let diff = resume_timestamp.getSeconds() - paused_timestamp.getSeconds(); //find difference between pause and resume time
  //     let date = new Date(data?.live_timestamp_db); //store live timestamp in date format
  //     date.setMinutes(date.getMinutes() + Number(data?.auction_duration)); //add auction duration into it
  //     if (diff < 0) { //if difference is smaller than 0 then add 1 minute along with diff into the final date
  //       date.setSeconds(date.getSeconds() + 60 + diff);
  //     } else {
  //       date.setSeconds(date.getSeconds() + diff); //else, difference is greater than 0 add only diff into final date
  //     }
  //     setTimerDate(date); //update final date
  //   } else {
  //     let date = new Date(data?.live_timestamp_db); //store live timestamp in date format
  //     date.setMinutes(date.getMinutes() + Number(data?.auction_duration)); //add auction duration into it
  //     setTimerDate(date); //update final date
  //   }
  // });
  let updatedTimes = onValue(updatedTimeRef, (snap) => {
    const data = snap.val(); //snapshot of the value
    if (data) {
      let date = new Date(data);
      setTimerDate(date);
    }
  });
  return () => {
    updatedTimes();
  };
};

/**
 * Fetches the bid list for an auction and updates the bid details and timer date.
 *
 * @function
 * @param {string} auction_id - The ID of the auction.
 * @param {Function} setbidDetails - Function to update the bid details.
 * @param {Function} setNewBidDetails - Function to update the number of new bids.
 * @param {Function} setTimerDate - Function to update the timer date.
 * @returns {Function} A cleanup function to unsubscribe from the database reference.
 */
export const getBidList = (
  auction_id,
  setbidDetails,
  setNewBidDetails,
  setTimerDate,
  setUpdatedBidDetails = () => {}
) => {
  const bidListFromDB = ref(database, `auctions/${auction_id}/bid_list`); //reference to firebase RTDB with respect to passed auctionId and child node bid_list
  const unSub = onValue(bidListFromDB, (snapshot) => {
    //listen to updated changes
    const data = snapshot.val(); //snapshot the changes
    if (data && data.length > 0) {
      //verify is data is present
      console.log(data,"READING FROM RTDB")
      setbidDetails(data); //set bid_list into state
      const noRejectedBids = data?.length > 0 ? data?.filter((d) => d?.is_valid === true) : [];
      setUpdatedBidDetails(noRejectedBids);
      setNewBidDetails(data.length); //set its length into another state
    }
  });

  updatedTime(auction_id, setTimerDate); //get the updated time
  return () => {
    unSub();
    updatedTime();
  };
};

/**
 * Fetches dashboard details for advanced auctions and updates the state.
 *
 * @function
 * @param {string} auction_id - The ID of the auction.
 * @param {Function} setDashboardDetails - Function to update the dashboard details.
 * @param {Function} setLiveTimestamp - Function to update the live timestamp.
 * @returns {Function} A cleanup function to unsubscribe from the database reference.
 */
export const getDashboardDetails = (
  auction_id,
  setDashboardDetails,
  setLiveTimestamp
) => {
  const dashboardFromDB = ref(database, `auctions/${auction_id}`); //reference to firebase RTDB with respect to passed auction_id
  const unSub = onValue(dashboardFromDB, (snapshot) => {
    //listen the changed data
    const data = snapshot.val(); //snapshot the data
    if (data) {
      //check if data is valid
      setDashboardDetails(data.dashboard); //update the details in state
      setLiveTimestamp(data.live_timestamp); //update the live timestamp in state
    }
  });
  return () => {
    unSub();
  };
};

/**
 * Updates the server timestamp for pause and resume actions in the database.
 *
 * @function
 * @param {string} auction_id - The ID of the auction.
 * @param {string} status - The status to set ("pause" or "resume").
 * @returns {void}
 */
export const paused_resume_db = (auction_id, status) => {
  const pausedTime = ref(database, `auctions/${auction_id}`); //reference to firebase RTDB with respect to passed auction_id
  let updated_time = {};

  if (status === "pause") {
    //check status value
    updated_time = {
      paused_at_db: serverTimestamp(), //get firebase RTDB timestamp and set to paused_at_db
    };
  } else {
    updated_time = {
      resumed_at_db: serverTimestamp(), //get firebase RTDB timestamp and set to resumed_at_db
    };
  }
  update(pausedTime, updated_time); //update the updated_time object
};

/**
 * Fetches the server timestamp offset for synchronization of timers for all users.
 *
 * @function
 * @param {Function} setOffset - Function to update the server offset.
 * @returns {Function} A cleanup function to unsubscribe from the database reference.
 */
export const db_time_stamp = (setOffset, time) => {
  // const offsetRef = ref(database, ".info/serverTimeOffset"); //get the offset from firebase RTDB
  // return onValue(offsetRef, (snap) => { //listen to the changed value
  //   const offset = snap.val(); //snapshot of the changed value
  //   if (offset) { //check if offset is present
  //       setOffset(offset); //set offset into the state
  //   }
  // });
  axios
    .get(Urls.worldAPI)
    .then((res) => {
      const currentDateTime = res?.data?.dateTime;
      const apiDate = new Date(currentDateTime);
      const localDate = new Date();
      const resDifference = localDate.getTime() - time;
      const timeDifference = apiDate.getTime() - localDate.getTime();
      const finalOffset = timeDifference + resDifference;
      setOffset(finalOffset);
    })
    .catch((error) => {
      // Handle any errors that occurred during the fetch operation
      console.error(
        "There has been a problem with your fetch operation:",
        error
      );
    });
};
/**

/**
 * Fetches and updates the status of the auction (active, paused, closed, resumed).
 *
 * @function
 * @param {string} auction_id - The ID of the auction.
 * @param {Function} setPausedAuction - Function to update the paused auction state.
 * @param {Function} setAuctionClosed - Function to update the closed auction state.
 * @param {Function} setreload_timer - Function to trigger a timer reload.
 * @param {boolean} reload_timer - Current state of the timer reload.
 * @param {Function} setPausedTimeStamp - Function to update the paused timestamp.
 * @returns {Function} A cleanup function to unsubscribe from the database reference.
 */
export const getAuctionStatus = (
  auction_id,
  setPausedAuction,
  setAuctionClosed,
  setreload_timer,
  reload_timer,
  setPausedTimeStamp
) => {
  const statusRef = ref(database, `auctions/${auction_id}/auction_status`);
  return onValue(statusRef, (snap) => {
    const data = snap.val();
    if (data) {
      if (data === "paused") {
        setPausedAuction(true);
        updatedPausedTImestamp(auction_id, setPausedTimeStamp);
        setreload_timer(!reload_timer);
      } else if (data === "closed") {
        setAuctionClosed(true);
      } else if (data === "active") {
        setPausedAuction(false);
        setreload_timer(!reload_timer);
      }
    }
    // else {
    //   setAuctionClosed(true);
    // }
  });
};

/**
 * Updates the block/unblock status of a transporter in the database.
 *
 * @function
 * @param {string} auction_id - The ID of the auction.
 * @param {string} transporter_status - The status to set for the transporter.
 * @param {string} id - The ID of the transporter.
 * @returns {void}
 */
export const transporterBlockUnblock = (auction_id, setTransporterList) => {
  const auctionStatus = ref(
    database,
    `auctions/${auction_id}/transporter_list`
  );
  const unSub = onValue(auctionStatus, (snapshot) => {
    const data = snapshot.val(); //get the snapshot of the value
    if (data && data.length > 0 && setTransporterList) {
      setTransporterList(data);
    }
  });
  return () => {
    unSub();
  };
};

/**
 * Fetches chat messages for a specific auction and updates the message list and unread status.
 *
 * @function
 * @param {string} auctionId - The ID of the auction.
 * @param {Function} setMessageList - Function to update the chat message list.
 * @param {Function} setHasUnreadChats - Function to update the unread chat status.
 * @returns {Function} A cleanup function to unsubscribe from the database reference.
 */
export const getChats = (auctionId, setMessageList, setHasUnreadChats) => {
  // Reference to the chat messages for the specified auction
  const chats = ref(database, `chat/${auctionId}/message_list`);

  // Set up a listener to handle updates to the chat messages
  const unsub = onValue(chats, (snapshot) => {
    const newChats = snapshot.val();

    if (newChats) {
      // Update the message list with the new chats
      setMessageList(newChats);

      // Determine unread messages for each transporter
      const unreadChats = newChats?.map((chat) => {
        const unreadMessages = chat?.messages?.filter(
          (message) =>
            !message?.read_status && message?.user_type === "transporter"
        );
        return {
          transporter_id: chat.transporter_id,
          messages: unreadMessages,
        };
      });

      // Check if there are no unread chats
      if (unreadChats && unreadChats?.length === 0) {
        return setHasUnreadChats(false);
      }

      // Check if all transporters have no unread messages
      if (unreadChats?.every((c) => c.messages?.length === 0)) {
        return setHasUnreadChats(false);
      }

      // Check if there are any unread messages
      if (unreadChats?.some((c) => c.messages?.length > 0)) {
        return setHasUnreadChats(true);
      }
    }
  });

  // Return a cleanup function to unsubscribe from the chat messages listener
  return () => {
    unsub();
  };
};

/**
 * Formats a string by adding a space between letters and numbers.
 *
 * @function
 * @param {string} round - The string to format.
 * @returns {string} The formatted string.
 */
export function formatRound(round) {
  if (round) {
    // Insert a space between a letter and a following number
    const formattedRound = round.replace(/([a-zA-Z])([0-9])/g, "$1 $2");
    return formattedRound;
  }
}

/**
 * Logs changes to the master data, including action, change activity, screen, and ID.
 *
 * @function
 * @param {string} [action=undefined] - The action performed.
 * @param {string} [change_activity=undefined] - The change activity.
 * @param {string} [screen=undefined] - The screen where the change occurred.
 * @param {string} [id=undefined] - The ID related to the change.
 * @param {string} [userId=undefined] - The current user's ID.
 * @param {string} [userEmail=undefined] - The current user's email.
 * @returns {void}
 */
export const MastersChangeLog = (action, change_activity, screen, id, userId, userEmail) => {
  // Construct the payload object with the necessary data
  const payload = {
    action: action,
    application: "Lorri",
    change_activity: change_activity,
    screen: screen,
    timestamp: currentRequestTimeStamp(), // Ensure this function is defined elsewhere in your code
    user_id: userId,
    user_email: userEmail,
    procurement_id: id,
  };

  // Post the payload to the change log endpoint
  Axios.post(`${Urls.planning}/change_log`, payload) // Ensure Axios and Urls are available in your context
    .then((res) => { })
    .catch((error) => {
      // Log any errors that occur during the request
      console.log(error);
    });
};

/**
 * Decrypts a base64 encoded, AES-encrypted response using a hex key.
 *
 * @function
 * @param {string} encryptedResponse - The base64 encoded encrypted response to decrypt.
 * @returns {Object|null} The decrypted JSON object, or null if decryption fails.
 */
export const decryptResponse = (encryptedResponse) => {
  try {
    let hex_key = DECRYPTION_KEY_HEX;
    const key = CryptoJS.enc.Hex.parse(hex_key);
    // Convert the base64 encoded string to a WordArray
    const encryptedDataWithIV = CryptoJS.enc.Base64.parse(encryptedResponse);

    // Extract the IV and the encrypted data
    const iv = CryptoJS.lib.WordArray.create(
      encryptedDataWithIV.words.slice(0, 4)
    );
    const encryptedData = CryptoJS.lib.WordArray.create(
      encryptedDataWithIV.words.slice(4)
    );

    // Decrypt the data
    const decryptedData = CryptoJS.AES.decrypt(
      { ciphertext: encryptedData },
      key,
      { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    // Convert the decrypted data to a string
    const decryptedStr = CryptoJS.enc.Utf8.stringify(decryptedData);

    // Parse the JSON string into an object
    return JSON.parse(decryptedStr);
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

/**
 * Encrypts a JSON payload using AES encryption and returns the result as a base64 encoded string.
 *
 * @function
 * @param {Object} payload - The payload to encrypt.
 * @returns {string|null} The base64 encoded encrypted payload, or null if encryption fails.
 */
export const encryptPayload = (payload) => {
  // try {
  //   // Retrieve the key from environment variables
  //   let hex_key = process.env.REACT_APP_DECRPTION_KEY_HEX;
  //   const key = CryptoJS.enc.Hex.parse(hex_key);

  //   // Generate a random Initialization Vector (IV)
  //   const iv = CryptoJS.lib.WordArray.random(16); // AES uses 16 bytes IV

  //   // Convert the payload to a string
  //   const payloadStr = JSON.stringify(payload);

  //   // Encrypt the payload
  //   const encryptedData = CryptoJS.AES.encrypt(payloadStr, key, {
  //     iv: iv,
  //     mode: CryptoJS.mode.CBC,
  //     padding: CryptoJS.pad.Pkcs7
  //   });

  //   // Combine the IV and the encrypted data
  //   const ivAndEncryptedData = CryptoJS.lib.WordArray.create([
  //     ...iv.words,
  //     ...encryptedData.ciphertext.words
  //   ]);

  //   // Encode the combined result to base64
  //   const encryptedResponse = CryptoJS.enc.Base64.stringify(ivAndEncryptedData);

  //   return encryptedResponse;
  // } catch (error) {
  //   console.error("Encryption failed:", error);
  //   return null;
  // }
  return payload;
};
export const getFilesData = (setData, setEmptyColumns, presentData, presentEmptyColumns, dispatch) => {
  dispatch(setData(presentData))
  dispatch(setEmptyColumns(presentEmptyColumns))
}

export const getFileHeader = (e, setFile, setUploadedFileFormat, selectedFileFormat, setInvalidMessege, dispatch) => {
  const file = e.target.files[0]
  if (!file) return;
  dispatch(setFile(e.target.files[0]));
  const reader = new FileReader();
  reader.onload = (event) => {
    const data = new Uint8Array(event.target.result);
    const workbook = XLSX.read(data, { type: "array" });
    const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
    if (!firstSheet) {
      toast.error("No data found in the sheet");
      return;
    }
    const allData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
    if (allData.length > 0) {
      var headers = allData[0];
      setUploadedFileFormat(headers);
    }
    handleErrorMessege(headers, selectedFileFormat, setInvalidMessege);
  };
  reader.readAsArrayBuffer(file);
};

export const handleErrorMessege = (
  headers,
  selectedFileFormat,
  setInvalidMessege
) => {
  let flag = false;
  headers.map((item, index) => {
    if (selectedFileFormat && selectedFileFormat.length === 0) {
      flag = true;
    }
    if (item !== selectedFileFormat?.all_keys?.[index]?.label) {
      flag = true;
    }
  });
  if (flag === true && selectedFileFormat.length !== 0) {
    setInvalidMessege("Headers did not match");
  } else if (flag === true) {
    setInvalidMessege("Select a format from dropdown");
  } else if (headers && headers.length === 0) {
    setInvalidMessege("Upload a file");
  } else {
    setInvalidMessege("");
  }
}
export const checkIfFormatMatch = (uploadedFileFormat, selectedFileFormat, setStep, setData, setEmptyColumns, setFinalKeys, setTotalRequiredFields, dispatch) => {
  let flag = false;
  if (uploadedFileFormat.length !== selectedFileFormat?.all_keys.length) {
    flag = true;
  }
  uploadedFileFormat.map((item, index) => {
    if (item !== selectedFileFormat?.all_keys?.[index]?.label) {
      flag = true;
    }
  });
  if (flag === true) {
    toast.error("Please upload valid file");
    return false;
  } else {
    dispatch(setData(selectedFileFormat?.all_keys))
    dispatch(setEmptyColumns(selectedFileFormat?.empty_values))
    dispatch(setFinalKeys(selectedFileFormat?.header_map))
    if (selectedFileFormat?.total_required_fields) {
      setTotalRequiredFields(selectedFileFormat?.total_required_fields);
    }
    dispatch(setStep(1))
  }
};

export const handleFileChange = (e, setFile, setData, setEmptyColumns, setStep, setIsInvalidData, viewed, dispatch) => {
  const file = e.target.files[0];
  if (!file) return;
  dispatch(setFile(file));
  const reader = new FileReader();
  reader.onload = (event) => {
    const data = new Uint8Array(event.target.result);
    const workbook = XLSX.read(data, { type: "array" });
    const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
    if (!firstSheet) {
      toast.error("No data found in the sheet");
      return;
    }

    // Read the entire data as an array of arrays
    const allData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
    // Check if there is at least one row of data
    if (allData.length > 0) {
      // Ensure there's at least the header and one row of data
      const headers = allData[0]; // Get the header row
      // Create an array of objects in label-value format
      // const labelValueArray = headers.map((header, index) => ({
      //   label: header,
      //   value: header // Use empty string if no value
      // }));
      const labelValueArray = headers
        .filter(
          (header) => header !== "" && header !== null && header !== undefined
        )
        .map((header, index) => ({
          label: header,
          value: header, // Use empty string if no value
        }));

      // Check for completely empty columns
      const _emptyColumns = [];
      const columnCount = headers.length;
      const rowCount = allData.length;
      let finalInvalids = [];
      for (let col = 0; col < columnCount; col++) {
        let isEmpty = true;

        for (let row = 1; row < rowCount; row++) {
          if (allData[row][col] !== undefined && allData[row][col] !== "") {
            isEmpty = false;
            break;
          } else {
            finalInvalids.push(`In ${allData[0][col]}, row ${row} is Empty`);
          }
        }
        setIsInvalidData(finalInvalids);
        if (isEmpty) {
          _emptyColumns.push(headers[col]);
        }
      }
      // if (!isUploadFileScreen) {
      dispatch(setData(labelValueArray)); // Use setData to store the label-value objects
      setEmptyColumns(_emptyColumns)
      // }
      // Store the label-value array in state
      if (viewed) {
        dispatch(setStep(1))
      } else if (finalInvalids.length === 0) {
        dispatch(setStep(1))
      }
      // else {
      // if (!isUploadFileScreen) {
      // setStep(4)
      // }
      // }
      // } else {
      // if (!isUploadFileScreen) {
      // setData([]); // Use setData to store the label-value objects
      // setEmptyColumns([])
      // }
    }
  };
  dispatch(setStep(1))
  reader.readAsArrayBuffer(file); // Read the file as an ArrayBuffer
};

export const isSuperUser = (contact_info, userEmail, userCompanyName) => {
  let isSuperAdmin;
  let organizationList = [];
  let isOrgListPresent = false;
  if (contact_info && contact_info.length > 0) {
    contact_info.map((item) => {
      if (item.email === userEmail) {
        if (item.organization && item.organization.length > 0) {
          organizationList = item.organization;
          isOrgListPresent = true;
        } else {
          isOrgListPresent = false;
          let companyName = userCompanyName ?? "company";
          organizationList = [{ name: companyName, id: "company" }];
        }
      }
    });
  }
  return { isSuperAdmin, organizationList, isOrgListPresent };
};

export const closeModal = (closeButtonId = "close_contactus") => {
  const closeButton = document.getElementById(closeButtonId);
  if (closeButton) {
    closeButton.click();
  }
};

export const handleKeyDown = (event) => {
  const nonNumericKeys = ["e", ".", "-", "E", "+"];

  if (nonNumericKeys.includes(event.key)) {
    event.preventDefault();
    toast.info("Please enter numeric values only.");
  }
};

/**
 * converts timestamp to format - dd-mm-yyyy, HH:MM AM/PM
 * @param {any} timestamp
 * @returns {any} dd-mm-yyyy, HH:MM AM/PM
 */
export function formatTimestamp(timestamp) {
  // Create a new Date object from the input timestamp
  const date = new Date(timestamp);

  // Options for date formatting
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    // second: "2-digit",
    hour12: true, // 12-hour format
  };

  // Format the date using toLocaleString
  const formattedDate = date.toLocaleString("en-GB", options);

  // Convert format from "dd/mm/yyyy, hh:mm:ss AM/PM" to "dd-mm-yyyy hh:mm AM/PM"
  const [datePart, timePart] = formattedDate.split(", ");
  const [day, month, year] = datePart.split("/");
  const formattedTime =
    timePart.slice(0, 5) + " " + timePart.slice(6).toLocaleUpperCase(); // Extract AM/PM properly

  return `${day}-${month}-${year}, ${formattedTime}`;
}

export function formatDuration(minutes) {
  const days = Math.floor(minutes / 1440); // 1 day = 1440 minutes
  const hours = Math.floor((minutes % 1440) / 60); // 1 hour = 60 minutes
  const mins = minutes % 60; // remaining minutes
  const seconds = 0; // Since we don't have seconds, this is set to 0

  let formattedDuration = "";

  if (days > 0) formattedDuration += `${days}d `;
  if (hours > 0) formattedDuration += `${hours}h `;
  if (mins > 0) formattedDuration += `${mins}m `;
  if (seconds > 0) formattedDuration += `${seconds}s`;

  // Trim any trailing space and return the formatted string
  return formattedDuration.trim();
}

/**
 * Strips special characters from a string, allowing specified exceptions.
 * Uses a pre-built regex lookup table instead of dynamic RegExp() construction
 * to prevent Regular Expression Denial-of-Service (ReDoS) attacks.
 * Fixes: CONS-009 (A05:2021 - Security Misconfiguration)
 *
 * @param {string} input - The input string to process.
 * @param {string} exceptions - Optional. Characters to allow beyond alphanumeric and hyphens.
 *                              Must be one of: "", "@", ".", "_", "@.", "_.", "@._"
 * @returns {string} - The processed string with disallowed characters removed.
 */

const ALLOWED_EXCEPTION_SETS = {
  "":    /[^a-zA-Z0-9-]/g,
  "@":   /[^a-zA-Z0-9-@]/g,
  ".":   /[^a-zA-Z0-9-.]/g,
  "_":   /[^a-zA-Z0-9-_]/g,
  "@.":  /[^a-zA-Z0-9-@.]/g,
  "_.":  /[^a-zA-Z0-9-_.]/g,
  "@._": /[^a-zA-Z0-9-@._]/g,
};

export const stripSpecialChars = (input, exceptions = "") => {
  const regex = ALLOWED_EXCEPTION_SETS[exceptions];

  if (!regex) {
    console.warn(`stripSpecialChars: unknown exceptions value "${exceptions}", defaulting to strict mode`);
    return input.replace(/[^a-zA-Z0-9-]/g, "");
  }

  return input.replace(regex, "");
};

export const validatePercentage = (percentage) => {
  if (
    typeof percentage !== "number" ||
    isNaN(percentage) ||
    percentage < 0 ||
    percentage > 100
  ) {
    return false;
  }
  return true;
};

export const isValidUrl = (urlString) => {
  try {
    new URL(urlString);
    return true;
  } catch (_) {
    return false;
  }
};
